"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Recent = function Recent() {
	return _react2.default.createElement(
		"g",
		{ id: "recent" },
		_react2.default.createElement("path", { d: "M262.39,0C168,0,90.11,54.82,51.8,135L0,75.34V229.08H142.31l-57-57.64c25.77-73.21,95.45-123.3,177.06-123.3,103.49,0,187.7,85.1,187.7,188.6s-84.21,188.17-187.7,188.17c-72.12,0-138.72-41.9-169.68-107.05L47.64,339.37c39.17,82.47,123.48,135.84,214.75,135.84,131,0,237.61-106.6,237.61-237.61S393.4,0,262.39,0Z" }),
		_react2.default.createElement("polygon", { points: "232.92 112.62 232.92 261.72 336.44 333.21 356.75 305.52 266.19 243.91 266.19 112.62 232.92 112.62" })
	);
};

exports.default = Recent;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Recent.js
// module id = 2979
// module chunks = 4